import React from "react";
import { Stack, Typography, Button } from "@mui/material";
import { TextField } from "../inputs";
import { useFormik } from "formik";
import * as Yup from "yup";

export interface RecoverPasswordFormInterface {
  initialData: { phone: string };
  handleAction: (type: string, data: any) => void;
  schema: any;
}

const RecoverPasswordForm = ({
  initialData,
  handleAction,
  schema,
}: RecoverPasswordFormInterface) => {
  const { values, handleChange, handleBlur, handleSubmit, touched, errors } =
    useFormik({
      initialValues: initialData,
      validationSchema: Yup.object(schema),
      onSubmit: (value) => handleAction("submit", value),
    });
  return (
    <form onSubmit={handleSubmit} style={{ width: "100%", height: "100%" }}>
      <Stack
        alignItems="center"
        justifyContent="space-between"
        width="100%"
        height="100%"
      >
        <Typography variant="h1" fontWeight={700} textAlign="center">
          Add a phone number for security
        </Typography>
        <Stack width="100%" spacing={0.5}>
          <TextField
            label="Phone number"
            name="phone"
            id="phone"
            placeholder="phone"
            helperText={touched.phone ? errors.phone : ""}
            error={touched.phone && Boolean(errors.phone)}
            value={values.phone}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <Typography color="primary">
            <i className="far fa-check"></i> Phone number added successfully
          </Typography>
        </Stack>

        <Button
          sx={{ alignSelf: "flex-end" }}
          variant="contained"
          color="primary"
          onClick={() => handleSubmit()}
        >
          Send Code
        </Button>
      </Stack>
    </form>
  );
};
export default RecoverPasswordForm;
